export default __webpack_public_path__ + "7e4661b54718bc572cdd5e32eec22804.svg";